module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs-groups panel panel-default"
  }, [_c('div', {
    staticClass: "list-groups",
    attrs: {
      "data-infinite-scroll": ""
    }
  }, [_c('panel-search', {
    staticClass: "panel-search-light",
    attrs: {
      "placeholder": "Введите наименование для поиска"
    },
    on: {
      "search": _vm.search
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.groups), function(group) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "href": ("/groups/" + (group.id))
      }
    }, [_vm._v(_vm._s(group.name))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(group.salons_count))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(group.supervisor ? group.supervisor.full_name : ''))])])
  }))]), _vm._v(" "), (_vm.next_page_url) ? _c('button', {
    staticClass: "load-more",
    on: {
      "click": _vm.loadNextPage
    }
  }, [_vm._v("Еще")]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Группа")]), _vm._v(" "), _c('th', [_vm._v("Привязано салонов")]), _vm._v(" "), _c('th', [_vm._v("ФИО создателя")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f8995a98", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f8995a98"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ListGroups.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-f8995a98"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ListGroups.vue
// module chunks = 0